// DEPLOY: /var/www/woody.wtf/frontend/src/appearance.js
// Per-user appearance (Settings -> Appearance): theme (dark-ninja | light | auto) and candle overrides
// {up, down: '#hex', body: solid|hollow|hollow_up, wick: 'match'|'#hex'}; empty = the theme's default.
// Saved to the account (/api/users/appearance, table public.user_appearance) and to localStorage, which
// public/index.html reads before the bundle loads so the first paint is already in the right theme.
// Theme colours live in index.css; the chart re-reads them on the 'appearancechange' window event.
import api from './api';

const KEY = 'cn.appearance';
export const DEFAULTS = { theme: 'dark-ninja', candles: {} };
const CANDLE_VARS = { up: '--candle-up', down: '--candle-down', body: '--candle-body', wick: '--candle-wick' };
const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: light)') : null;

function loadLocal() {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || '{}') }; } catch (_) { return { ...DEFAULTS }; }
}

let current = loadLocal();

export const getAppearance = () => current;
export const resolvedTheme = (t = current.theme) => (t === 'auto' ? (media && media.matches ? 'light' : 'dark-ninja') : t);

export function applyAppearance(a) {
  current = { ...DEFAULTS, ...a, candles: { ...((a && a.candles) || {}) } };
  const root = document.documentElement;
  root.dataset.theme = resolvedTheme();
  Object.entries(CANDLE_VARS).forEach(([k, v]) => (current.candles[k] ? root.style.setProperty(v, current.candles[k]) : root.style.removeProperty(v)));
  try { localStorage.setItem(KEY, JSON.stringify(current)); } catch (_) {}
  const cs = getComputedStyle(root);
  if (window.Chart && window.Chart.defaults) {   // Chart.js (CDN) charts that set no colours of their own
    window.Chart.defaults.color = cs.getPropertyValue('--text-muted').trim();
    window.Chart.defaults.borderColor = cs.getPropertyValue('--grid').trim();
  }
  window.dispatchEvent(new Event('appearancechange'));
}

// After login: the account's saved appearance wins over this browser's copy.
export const loadAccountAppearance = () =>
  api.get('/users/appearance').then(r => { if (r.data.appearance) applyAppearance(r.data.appearance); }).catch(() => {});

export function saveAppearance(a) {
  applyAppearance(a);
  return api.put('/users/appearance', { appearance: current });
}

applyAppearance(current);
if (media && media.addEventListener) media.addEventListener('change', () => current.theme === 'auto' && applyAppearance(current));
